<div class="">
    <div class="">
        <h1 class="heading_del">
            {{count ? 'Delete ' + (count > 1 ? 'dishes' : 'dish') : 'Delete Menu'}}
        </h1>
    </div>
    <div class="">
        <p class="text_del" >
            {{count ? 'Are you sure you want to delete ' + count + ' ' + (count > 1 ? 'dishes' : 'dish')  : 'Are you sure you want to delete entire menu?'}}
        </p>

        <p *ngIf="!count">
            Note:- This action will delete all the dishes in the  current menu and is irreversible.
        </p>
    </div>
    <div class="del_btn_main_div">
        <button type="button" class="btn btn-default" (click)="close(false)">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="close(true)">Delete</button>
    </div>
</div>

<style>
    .mat-dialog-container {
        padding: 20px !important;
    }

    .text_del {
        font-size: 18px;
        text-align: center;
    }

    .del_btn_main_div {
        display: flex;
        justify-content: flex-end;
        margin-top: 3rem;
        gap: 15px;
    }
</style>